import { debounce } from 'lodash'
import { useEffect, useRef, useState } from 'react'

export const useWindowResize = () => {
    const isMountedRef = useRef(true)
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    })

    useEffect(() => {
        const handleResize = debounce(() => {
            if (!isMountedRef.current) return

            setSize({
                width: window.innerWidth,
                height: window.innerHeight,
            })
        }, 100)

        window.addEventListener('resize', handleResize)

        return () => {
            isMountedRef.current = false
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return size
}
